import '../Styles.css';
import { jwtDecode } from "jwt-decode";
import { Middleware, MiddlewareProvider } from './Middleware';
import axios from 'axios';
import React from 'react';
import { TokenValidateExpiration } from './Token';

const token = localStorage.getItem("token");
var decode = "";
var rfc = "";

if (token) {
    decode = jwtDecode(token);
    rfc = decode.rfc;
}

function sliceCLABE() {
    var clabe = document.getElementById("clabe").value;

    if (clabe.length == 18) {
        var cb = clabe
        let resMod10 = []

        for (let i = 0; i <= cb.length; i++) {
            let digitToAdd = 0
            //3
            if (i % 3 === 0 && cb[i]) {
                digitToAdd = cb[i] * 3
                resMod10[i] = +(digitToAdd + '')[1] || digitToAdd
            }
            //7
            else if (i % 3 === 1 && cb[i]) {
                digitToAdd = cb[i] * 7
                resMod10[i] = +(digitToAdd + '')[1] || digitToAdd
            }
            //1
            else {
                if (cb[i]) {
                digitToAdd = cb[i] * 1
                resMod10[i] = +(digitToAdd + '')[1] || digitToAdd
                }
            }
        }

        var step3 = resMod10.reduce((acc, el) => acc + el)
        var step4 = (step3 + '')[1] || (step3 + '')[0]
        var step5 = 10 - step4
        var step6 = (step5 + '')[1] || (step5 + '')[0]
        
        if (step6 != 0) {
            alert("Clave de banco no valida, consulte a su gestor");
            return;
        }

        var bankAccount = clabe.substr(6, 11);
        var bank = clabe.substr(0, 3);
        //bank = bank.replace("0", "");
        var plaza = clabe.substr(3, 3);
        var sucursal = clabe.substr(6, 3);

        //alert(clabe);
        //alert(bankAccount);
        //alert(bank);
        //alert(plaza);
        //alert(sucursal);

        // 002215904907940330

        document.getElementById("bankAccount").value = bankAccount;
        document.getElementById("bank").value = bank;
        document.getElementById("plaza").value = plaza;
        document.getElementById("sucursal").value = sucursal;
    } else {
        //alert("La CLABE tiene que contar con 18 digitos");
        document.getElementById("bankAccount").value = "";
        document.getElementById("bank").value = "";
        document.getElementById("plaza").value = "";
        document.getElementById("sucursal").value = "";
    }
}

function ProviderBankAccountsSave() {
    document.getElementById("ChgA").style.display = "block";
    document.getElementById("BtnA").style.display = "none";

   //restrict
   var checkBankExist = document.getElementById("checkBankExist").value;

   if(checkBankExist == 1){
    alert("Sólo puedes tener una cuenta bancaria");
    document.getElementById("ChgA").style.display = "none";
    document.getElementById("BtnA").style.display = "inline-block";
    document.getElementById("clabe").value = "";
    document.getElementById("bankAccount").value = "";
    document.getElementById("bank").value = "";
    document.getElementById("plaza").value = "";
    document.getElementById("sucursal").value = "";
    return;
   }


   //

    var cb = document.getElementById("clabe").value;
    let resMod10 = []

    for (let i = 0; i <= cb.length; i++) {
    let digitToAdd = 0
    //3
    if (i % 3 === 0 && cb[i]) {
        digitToAdd = cb[i] * 3
        resMod10[i] = +(digitToAdd + '')[1] || digitToAdd
    }
    //7
    else if (i % 3 === 1 && cb[i]) {
        digitToAdd = cb[i] * 7
        resMod10[i] = +(digitToAdd + '')[1] || digitToAdd
    }
    //1
    else {
        if (cb[i]) {
        digitToAdd = cb[i] * 1
        resMod10[i] = +(digitToAdd + '')[1] || digitToAdd
        }
    }
    }

    var step3 = resMod10.reduce((acc, el) => acc + el)
    var step4 = (step3 + '')[1] || (step3 + '')[0]
    var step5 = 10 - step4
    var step6 = (step5 + '')[1] || (step5 + '')[0]
    
    if (step6 != 0) {
        alert("Clave de banco no valida, consulte a su gestor");
        document.getElementById("ChgA").style.display = "none";
        document.getElementById("BtnA").style.display = "inline-block";
        return;
    }

   //

    //React.useEffect(() => {
        axios.post(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/bank-accounts/save/'+token, {
            IdUser: decode.id,
            TipoCuenta: document.getElementById("tipoCuenta").value,
            Clabe: document.getElementById("clabe").value,
            BankAccount: document.getElementById("bankAccount").value,
            Referencia1: document.getElementById("referencia1").value,
            Referencia2: document.getElementById("referencia2").value,
            TipoMoneda: document.getElementById("tipoMoneda").value,
            Beneficiario: document.getElementById("beneficiario").value,
        }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        window.scrollTo(0, 0);
        document.getElementById("ChgB").style.display = "none";
        document.getElementById("messageSuccess").style.display = "block";
        document.getElementById("messageSuccess").innerHTML = "Cuenta bancaria agregada exitosamente, recargando la pagina, por favor espere...";
        setTimeout(() => {
            window.location.href = '/proveedor-cuentas-bancarias';
        }, 3000);
    }
    )
    .catch(error => {
        document.getElementById("ChgA").style.display = "none";
        document.getElementById("BtnA").style.display = "inline-block";
        document.getElementById("messageError").innerHTML = error.response.data.error;
        console.log(error);
    })
    ;
    //}, []);
}

function ProviderRemoveBankAccount(id) {
    if(window.confirm("¿Estás seguro de eliminar la cuenta?") == false){
        return;
    }
    axios.post(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/bank-accounts/delete/'+token, {
            IdAccount: id,
            IdUser: decode.id,
            }, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            }
        ).then(response => {
            window.scrollTo(0, 0);
            document.getElementById("ChgB").style.display = "none";
            document.getElementById("messageSuccess").style.display = "block";
            document.getElementById("messageSuccess").innerHTML = "Cuenta bancaria eliminada exitosamente, recargando la pagina, por favor espere...";
            setTimeout(() => {
                window.location.href = '/proveedor-cuentas-bancarias';
            }, 3000);
        })
        .catch(error => {
            console.log(error);
        });
}

function ProviderFinishBankAccounts() {
    document.getElementById("ChgB").style.display = "block";
    document.getElementById("BtnB").style.display = "none";
    axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/status-control/finish/' + decode.id, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        console.log(response);
    }
)
.catch(error => {
    console.log(error);
    document.getElementById("Chg").style.display = "none";
    document.getElementById("Btn").style.display = "inline-block";
})
;

    localStorage.removeItem("token");
    window.location.href = '/';
}

function ProviderBankAccounts() {
    Middleware();
    MiddlewareProvider();

    const token = localStorage.getItem("token");
    TokenValidateExpiration(token);

    const [bankAccounts, setbankAccounts] = React.useState([]);
    const [bancos, setBancos] = React.useState([]);
    const [monedas, setMonedas] = React.useState([]);

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/bank-accounts/get/' + decode.id +'/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        setbankAccounts(response.data.BankAccount);
        setBancos(response.data.Bancos);
        setMonedas(response.data.Moneda);
    });
    }, []);

    ///api/provider/contacts/get/
    const [beneficiary, setBeneficiary] = React.useState([]);

    React.useEffect(() => {
        axios.get(process.env.REACT_APP_API_PORTAL_PROVEEDORES+'/api/provider/bank-accounts/beneficiary/get/' + decode.id +'/'+token, {}, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        }
    )
    .then(response => {
        setBeneficiary(response.data);
    });
    }, []);

    setTimeout(() => {
            beneficiary != ""
            &&
            (document.getElementById("beneficiario").value = beneficiary)
        }, 1000);
    
    return (
        <div className='Container'>
            <div className='Navbar'>
                <div>
                    <h5 className='text-white'>Portal de proveedores</h5>
                </div>
            </div>
            <div className='Section'>
                <div className='Header'>
                    <div className="text-center">
                        <div className='row'>
                            <div className='col-md-6 Text-left'>
                                <label className='mt-1 Text-Gray'><b>Usuario: </b>
                                    {  
                                        rfc
                                    }
                                </label>
                            </div>
                            <div className='col-md-6 Text-right'>
                                <a href='/logout'>
                                    <label>
                                        Cerrar sesión
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fillRule="currentColor" className="bi bi-box-arrow-right m-1" viewBox="0 0 16 16">
                                            <path fillRule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0z" />
                                            <path fillRule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708z" />
                                        </svg>
                                    </label>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='Article'>
                    <div className="text-center">
                        <h1 className='Text-Red'>Cuenta bancaria</h1>
                        <br></br>
                        <label className='text-gray'>
                            Completa el formulario para gregar una cuenta bancaria, sólo se podrá agregar una sola cuenta
                        </label>
                        <br></br>
                        <br></br>
                        <form action={ProviderBankAccountsSave}>
                            <div className='d-flex justify-content-center'>
                                <label id='messageError' className='Error-Notification'></label>
                            </div>
                            <div className='d-flex justify-content-center'>
                                <label id='messageSuccess' className='Success-Notification'></label>
                            </div>
                            <br></br>
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div>
                                        <label>Tipo de Cuenta<span>*</span></label>
                                        <br></br>
                                        <select name="tipoCuenta" id="tipoCuenta" aria-label="Default select example" className="form-select" required>
                                            <option value="">Selecciona...</option>
                                                {
                                                    monedas.map(item => (
                                                        <option value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                        </select>
                                        <label><span></span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div>
                                            <label>CLABE<span>*</span></label>
                                            <br></br>
                                            <input name="clabe" id="clabe" type="input" className="form-control" onChange={sliceCLABE} maxLength={18} required></input>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div>
                                            <label>Cuenta Bancaria<span>*</span></label>
                                            <br></br>
                                            <input name="bankAccount" id="bankAccount" type="input" disabled className="form-control" required></input>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div>
                                            <label>Banco<span></span></label>
                                            <br></br>
                                            <select name="bank" id="bank" aria-label="Default select example" disabled className="form-select">
                                                <option value="">Selecciona...</option>
                                                {
                                                    bancos.map(item => (
                                                        <option value={item.Codigo}>{item.Nombre}</option>
                                                    ))
                                                } 
                                            </select>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div>
                                            <label>Plaza<span></span></label>
                                            <br></br>
                                            <input name="plaza" id="plaza" disabled type="input" className="form-control"></input>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div>
                                            <label>Sucursal<span></span></label>
                                            <br></br>
                                            <input name="sucursal" id="sucursal" disabled type="input" className="form-control"></input>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div>
                                            <label>Referencia 1 (opcional)<span></span></label>
                                            <br></br>
                                            <input name="referencia1" id="referencia1" type="input" className="form-control" pattern="[áéíóúñÁÉÍÓÚÑ&a-zA-Z0-9\s]+" maxLength={25}></input>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div>
                                            <label>Referencia 2 (opcional)<span></span></label>
                                            <br></br>
                                            <input name="referencia2" id="referencia2" type="input" className="form-control" pattern="[áéíóúñÁÉÍÓÚÑ&a-zA-Z0-9\s]+" maxLength={30}></input>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                    <div className="col-sm-4">
                                        <div>
                                        <label>Tipo Moneda<span>*</span></label>
                                        <br></br>
                                        <select name="tipoMoneda" id="tipoMoneda" aria-label="Default select example" className="form-select" required>
                                            <option value="">Selecciona...</option>
                                            <option value="1">M.N. PESOS</option>
                                        </select>
                                        <label><span></span></label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xl-8 col-lg-12">
                                        <div>
                                            <label>Beneficiario<span>*</span></label>
                                            <br></br>
                                                <input name="beneficiario" id="beneficiario" placeholder="" type="input" className="form-control" pattern="[áéíóúñÁÉÍÓÚÑ&a-zA-Z0-9\s]+" required></input>
                                            <label><span></span></label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="text-center">
                                <i id="ChgA"className="fa fa-spinner fa-spin Chg"></i>
                                <input id='BtnA' type='submit' value='Guardar' className='Button-Style'></input>
                            </div>
                        </form>
                        <br></br>
                        <br></br>
                        <i id="ChgB"className="fa fa-spinner fa-spin Chg"></i>
                        {
                            bankAccounts
                            ?
                            <input type="hidden" id="checkBankExist" value="1"></input>
                            :
                            <input type="hidden" id="checkBankExist" value="0"></input>
                        }
                        {
                            bankAccounts 
                            &&
                            <div>
                                <table className="table table-hover">
                                    <thead>
                                        <tr>
                                            <th scope="col">Cuenta bancaria</th>
                                            <th scope="col">Clabe</th>
                                            <th scope='col'>Referencia 1</th>
                                            <th scope='col'>Referencia 2</th>
                                            <th scope="col">Beneficiario</th>
                                            <th scope="col"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            bankAccounts 
                                            &&
                                            bankAccounts.map(item => (
                                                <tr id={"bankAccount1"} key={"bankAccount"+item.id} value={"bankAccount"+item.id}>
                                                    <td>
                                                        {item.bankAccount}
                                                    </td>
                                                    <td>
                                                        {item.Clabe}
                                                    </td>
                                                    <td>
                                                        {item.Reference1}
                                                    </td>
                                                    <td>{item.Reference2}</td>
                                                    <td>{item.Beneficiary}</td>
                                                    <td>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash" viewBox="0 0 16 16" onClick={() => ProviderRemoveBankAccount(item.id)}>
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
                                                        <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
                                                    </svg>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                                <br></br>
                                <br></br>
                                <label className='text-gray'>
                                Al dar clic en "Finalizar" concluyes con el registro de tus datos, 
                                <br></br>
                                la sesión se cerrará y podrás acceder de nuevo cuando se hayan validado tus datos, recibirás una notificación con la retroalimentación de tu registro
                                </label>
                                <br></br>
                                <br></br>
                                <input id='BtnB' type='submit' value='Finalizar' className='Button-Style' onClick={ProviderFinishBankAccounts}></input>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProviderBankAccounts;